import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';

export const get2bapReportsModuleUrl = () =>
  `/${modulePaths[moduleCodes.MODULE_2BAP]}/${routePath.ROUTE_2BAP_EXTERNAL_IFRAME_REPORTS}`;
